import { render, staticRenderFns } from "./GDTFormType.vue?vue&type=template&id=3bdcae30&"
import script from "./GDTFormType.vue?vue&type=script&lang=js&"
export * from "./GDTFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports